import { __decorate } from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
import CurveLine from './curve-line.vue';
let default_1 = class default_1 extends Vue {
    // @Prop() readonly numData!: IUMC;
    daySummary;
    get direction() {
        const res = this.daySummary[0]?.dayOnDayPassCountGrowth >= 0;
        return res;
    }
    get absolute() {
        return Math.abs(this.daySummary[0]?.dayOnDayPassCountGrowth || 0);
    }
    get queueingCount() {
        return this.daySummary[0]?.totalPassCountPerDay;
    }
    mounted() { }
};
__decorate([
    Prop()
], default_1.prototype, "daySummary", void 0);
default_1 = __decorate([
    Component({
        name: 'ChartCross',
        components: { 'curve-line': CurveLine },
        i18n: {
            messages: {
                'en-us': {
                    dayNumber: 'Throughput (Today)',
                    dayOnDay: 'Trend',
                    people: 'ppl',
                },
                zh: {
                    dayNumber: '排队通行人数(今日)',
                    dayOnDay: '日同比',
                    people: '人',
                },
            },
        },
    })
], default_1);
export default default_1;
